import { render, staticRenderFns } from "./newGuidance.vue?vue&type=template&id=0929a7a2&scoped=true&"
import script from "./newGuidance.vue?vue&type=script&lang=js&"
export * from "./newGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929a7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0929a7a2')) {
      api.createRecord('0929a7a2', component.options)
    } else {
      api.reload('0929a7a2', component.options)
    }
    module.hot.accept("./newGuidance.vue?vue&type=template&id=0929a7a2&scoped=true&", function () {
      api.rerender('0929a7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/newGuidance/newGuidance.vue"
export default component.exports